import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { Link, useNavigate } from "react-router-dom";
import { Tab, Tabs, useMediaQuery, Stack, Divider } from "@mui/material";
import Logo from "./Logo";
import { useAuth } from "../../contexts/AuthContext";

import HomeIcon from "@mui/icons-material/Home";
import GroupWorkSharpIcon from "@mui/icons-material/GroupWorkSharp";
import MiscellaneousServicesSharpIcon from "@mui/icons-material/MiscellaneousServicesSharp";
import CurrencyExchangeSharpIcon from "@mui/icons-material/CurrencyExchangeSharp";
import MailSharpIcon from "@mui/icons-material/MailSharp";
import FeedIcon from "@mui/icons-material/Feed";

const ResponsiveAppBar = () => {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const links = [
    { route: "/", label: "ACCUEIL", icone: <HomeIcon /> },
    { route: "/aboutus", label: "QUI SOMMES NOUS ?", icone: <GroupWorkSharpIcon /> },
    { route: "/services", label: "SERVICES", icone: <MiscellaneousServicesSharpIcon /> },
    { route: "/reservation", label: "RESERVATION", icone: <CurrencyExchangeSharpIcon /> },
    { route: "/actualites", label: "ACTUALITES", icone: <FeedIcon /> },
    { route: "/contact", label: "CONTACT", icone: <MailSharpIcon /> },
  ];

  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleLogout = async () => {
    try {
      await logout();
      window.location.href = "/";
    } catch (error) {
      console.log(error);
      window.alert("La déconnexion a échoué. Vérifiez votre connexion et réessayez.");
    }
  };

  const handleOpenNavMenu = (event) => setAnchorElNav(event.currentTarget);
  const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);

  const handleCloseNavMenu = (r) => {
    setAnchorElNav(null);
    if (typeof r === "string") navigate(r);
  };

  const handleCloseUserMenu = (r) => {
    setAnchorElUser(null);
    if (typeof r === "string") navigate(r);
  };

  return (
<AppBar position="sticky" sx={{ backgroundColor: "black" }}>
<Toolbar
  sx={{
    width: "100%",
    px: { xs: 2, sm: 4, md: 8 },
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
  }}
>
  {/* Menu hamburger (à gauche sur mobile) */}
  <Box sx={{ display: { xs: "flex", md: "none" }, mr: 1 }}>
    <IconButton
      size="large"
      onClick={handleOpenNavMenu}
      color="inherit"
      aria-label="menu"
    >
      <MenuIcon />
    </IconButton>
    <Menu
      anchorEl={anchorElNav}
      open={Boolean(anchorElNav)}
      onClose={handleCloseNavMenu}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      sx={{ display: { xs: "block", md: "none" } }}
    >
      {links.map((link, index) => (
        <MenuItem key={index} onClick={() => handleCloseNavMenu(link.route)}>
          <Stack direction="row" spacing={1} alignItems="center">
            <IconButton size="small" color="inherit">
              {link.icone}
            </IconButton>
            <Typography>{link.label}</Typography>
          </Stack>
        </MenuItem>
      ))}
    </Menu>
  </Box>

  {/* Logo centré sur mobile */}
  <Box
    sx={{
      position: "absolute",
      left: 0,
      right: 0,
      top: "50%",
      transform: "translateY(-50%)",
      display: { xs: "flex", md: "none" },
      justifyContent: "center",
      pointerEvents: "none",
      zIndex: 0,
    }}
  >
    <Box sx={{ pointerEvents: "auto" }}>
      <Logo />
    </Box>
  </Box>

  {/* Logo à gauche sur desktop */}
  <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
    <Logo />
  </Box>

  {/* Menu principal (desktop uniquement) */}
  <Box
    sx={{
      flexGrow: 1,
      display: { xs: "none", md: "flex" },
      justifyContent: "center",
    }}
  >
    <Tabs textColor="inherit" value={value} indicatorColor="primary">
      {links.map((link, index) => (
        <Link
          to={link.route}
          key={index}
          style={{ textDecoration: "none", color: "white" }}
        >
          <Tab
            label={
              <Stack direction="row" spacing={1} alignItems="center">
                <IconButton size="small" color="inherit" sx={{ p: 0.2 }}>
                  {link.icone}
                </IconButton>
                {link.label}
              </Stack>
            }
            onClick={() => setValue(index)}
          />
        </Link>
      ))}
    </Tabs>
  </Box>

  {/* ✅ Partie utilisateur ou connexion à droite — inchangée */}
  <Box sx={{ display: "flex", alignItems: "center" }}>
    {user ? (
      <Box sx={{ flexGrow: 0 }}>
        <Tooltip title="Open settings">
          <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
            <Avatar alt="User" src="/images/bureaux/b2.jpg" />
          </IconButton>
        </Tooltip>
        <Menu
          anchorEl={anchorElUser}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
          sx={{ mt: "45px" }}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Box sx={{ p: 2 }}>
            <Stack direction="row" spacing={2} justifyContent="space-around">
              <Stack direction="column" spacing={1}>
                <Typography variant="h5">{user?.user?.name}</Typography>
                <Typography variant="subtitle2">
                  {user?.user?.email}
                </Typography>
              </Stack>
              <Avatar alt="User" src="/images/bureaux/b2.jpg" />
            </Stack>
            <Button variant="contained" onClick={handleLogout}>
              Déconnexion
            </Button>
            <Divider />
          </Box>
          <MenuItem onClick={() => handleCloseUserMenu("/profile")}>
            <Typography textAlign="center">Profile</Typography>
          </MenuItem>
          {(user?.user?.roles?.includes("admin") ||
            user?.user?.roles?.includes("supadmin")) && (
            <MenuItem onClick={() => handleCloseUserMenu("/admin")}>
              <Typography textAlign="center">Tableau de bord</Typography>
            </MenuItem>
          )}
        </Menu>
      </Box>
    ) : (
      <Stack direction="row" spacing={2} sx={{ fontSize: { xs: 12, sm: 16 } }}>
        <Link
          to="/login"
          style={{ textDecoration: "none", color: "goldenrod" }}
        >
          Connexion
        </Link>
        <Link
          to="/register"
          style={{ textDecoration: "none", color: "goldenrod" }}
        >
          S'inscrire
        </Link>
      </Stack>
    )}
  </Box>
</Toolbar>

</AppBar>

  );
};

export default ResponsiveAppBar;
